import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import Home from "@/pages/Home";
import ReportWizard from "@/pages/ReportWizard";
import CaseTracker from "@/pages/CaseTracker";
import KnowledgeHub from "@/pages/KnowledgeHub";
import AdminDashboard from "@/pages/AdminDashboard";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import Disclaimer from "@/pages/Disclaimer";
import VolunteerSignup from "@/pages/VolunteerSignup";
import DonateNow from "@/pages/DonateNow";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

function App() {
  return (
    <div className="App min-h-screen flex flex-col bg-[#F8F9FA]">
      <BrowserRouter>
        <Navbar />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/report" element={<ReportWizard />} />
            <Route path="/track" element={<CaseTracker />} />
            <Route path="/knowledge" element={<KnowledgeHub />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfUse />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/volunteer" element={<VolunteerSignup />} />
            <Route path="/donate" element={<DonateNow />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
